import React from 'react';
import { useTranslation } from '../context/TranslationContext';
import { Link } from 'react-router-dom';
import Logo from './Logo';

const COPY = {
  es: {
    links: [['Qué hacemos', '/#que-hacemos'], ['Haz la cuenta', '/#cuenta'], ['Cómo trabajamos', '/#como-trabajamos'], ['Preguntas', '/#faq'], ['Contacto', '/#contacto']],
    nav: 'Pie de página',
    legal: 'Estudio de software e IA en España. También trabajamos en remoto con Latinoamérica.',
    privacy: 'Privacidad',
  },
  en: {
    links: [['What we do', '/#que-hacemos'], ['Do the sum', '/#cuenta'], ['How we work', '/#como-trabajamos'], ['Questions', '/#faq'], ['Contact', '/#contacto']],
    nav: 'Footer',
    legal: 'Software and AI studio in Spain.',
    privacy: 'Privacy',
  },
};

export default function Footer() {
  const { lang } = useTranslation();
  const c = COPY[lang] || COPY.es;

  return (
    <footer className="site-footer">
      <div className="wrap footer-grid">
        <Logo onNavy />
        <nav aria-label={c.nav} className="footer-nav">
          {c.links.map(([label, href]) => <a key={href} href={href}>{label}</a>)}
        </nav>
        <div className="footer-contact">
          <a href="mailto:contact@qyntix.com">contact@qyntix.com</a>
          <a href="https://www.linkedin.com/company/qyntix" target="_blank" rel="noopener noreferrer">LinkedIn</a>
        </div>
        <p className="footer-legal">© {new Date().getFullYear()} Qyntix. {c.legal} · <Link to="/privacidad">{c.privacy}</Link></p>
      </div>
    </footer>
  );
}
